export default __webpack_public_path__ + "static/media/carousel_2.cf7f3b1a.jpg";